module.exports = __webpack_public_path__ + "img/prelude.2f5f6691.png";